// Companion voice lines (practice-loop-v2 dogfood round: 主公 feedback
// 「沒特別感受到三個小動物的特殊感」→ ABCD 全做). Pure data + picker so the
// personality split is testable. UI-only copy — deliberately NOT in
// @skena/schema, which carries shared display copy only.

import type { CompanionId } from '@skena/schema'

/** C. 開場招呼 — personality-flavored round greetings. */
export const GREETINGS: Record<CompanionId, readonly string[]> = {
  sparrow: ['我陪你慢慢來！', '別怕，一題一題來。', '天父看顧你，也看顧我！'],
  eagle: ['展翅的時候到了！', '跟我一起飛高高！', '今天要騰空而起！'],
  donkey: ['和散那！出發囉！', '我載過君王，也陪你走！', '一起去冒險！'],
}

/** D. 答對微反應 — short cheers, bubble lives ~1s. */
export const CHEERS: Record<CompanionId, readonly string[]> = {
  sparrow: ['好棒！', '答對了！', '天父笑了！'],
  eagle: ['漂亮！', '再飛高一點！', '衝！'],
  donkey: ['耶！', '踏踏跳跳！', '好耶！'],
}

/** B. 被動觸發的署名台詞. */
export const PASSIVE_LINES: Record<CompanionId, string> = {
  sparrow: '沒關係，天父看顧你，連對還在！',
  eagle: '重新得力，展翅上騰！',
  donkey: '和散那！大家一起慶祝！',
}

export function pickLine(lines: readonly string[], random: () => number = Math.random): string {
  return lines[Math.floor(random() * lines.length)] ?? lines[0]!
}
